<template>
  <label id="search-bar">
    <VueTypeaheadBootstrap
      v-model.trim="inputVal"
      :data="merchantNames ? merchantNames : []"
      :serializer="item => item.name"
      :placeholder="placeholder"
      :maxMatches="10"
      :minMatchingChars="0"
    >
      <template slot="append" v-if="inputVal">
        <b-input-group-append>
          <b-input-group-text>
            <b-icon-x @click="emptySearchName"></b-icon-x>
          </b-input-group-text>
        </b-input-group-append>
      </template>
    </VueTypeaheadBootstrap>
  </label>
</template>

<script>
import { mapGetters } from 'vuex';
import vModelMixin from '@/mixins/v-model';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import axios from 'axios';
import {
  BInputGroupAppend, BInputGroupText, BIconX,
} from 'bootstrap-vue';
import {
  debounceTime,
  tap,
} from 'rxjs/operators';

export default {
  name: 'SearchBar',
  mixins: [vModelMixin],
  data: () => ({
    merchantNames: [],
  }),
  computed: {
    ...mapGetters(['role']),
  },
  subscriptions() {
    return {
      merchantNames: this.$watchAsObservable('inputVal').pipe(
        debounceTime(500),
        tap(() => {
          axios
            .get(`/agc-${this.role}-api/merchants/getMerchantNames?name=${this.inputVal}`)
            .then(({ data: { payload } }) => payload)
            .then((res) => {
              if (res) {
                this.merchantNames = res;
              }
            })
            .catch((error) => {
              console.log(error);
            })
            .finally();
        }),
      ),
    };
  },
  methods: {
    emptySearchName() {
      this.inputVal = null;
    },
  },
  components: {
    VueTypeaheadBootstrap,
    BInputGroupAppend,
    BInputGroupText,
    BIconX,
  },
  props: {
    placeholder: { type: String, default: '關鍵字...' },
  },
};
</script>

<style lang="scss" scoped>
#search-bar {
  position: relative;
  display: inline-block;

  input {
    padding-left: 30px;
  }
  &:before {
    content: "";
    position: absolute;
    width: 24px;
    height: 24px;
    top: 8px;
    left: 8px;

    background: url(../assets/img/search.svg) no-repeat center center;
  }
}
</style>
